// React
import { useState } from "react"

// UI
import { PageTemplate } from "@/layouts/PageTemplate"
import { InvestmentOpportunityBanner } from "@/components/banners/InvestmentOpportunityBanner"

// Specific UI
import { ProjectsOverviewTable } from "./_components/ProjectsOverview"
import { FundedAmountPieChart } from "./_components/FundedAmountPieChart"
import { FinancialPerformanceGraph } from "./_components/FinancialPerformanceGraph"
import { ExpectedVsActualGraph } from "./_components/ExpectedVsActualGraph"
import { ProjectTypeBonds } from "./_components/ProjectTypeBonds"
import { ProjectTypeSolarFundsInfo } from "./_components/ProjectTypeSolarFundsInfo"
import { ProjectTypeSolarLeaseInfo } from "./_components/ProjectTypeSolarLeaseInfo"
import { ProjectOwnersOverview } from "./_components/ProjectOwnersOverview"

// Translations
import { useTrans } from "@/i18n"

// Context
import { useAuth, AuthStateStatusEnum } from "@/context/useAuth"
import { useCurrentUserRoles } from "@/context/user"

// Types
import { ProjectTypeEnum } from "@/api/graphql/types"

// Constants
import { ProjectBondsTypes, UserRoles } from "@/constants/constants"

/**
 * StatisticsPlatform
 * @param param0
 * @returns
 */
export function StatisticsPlatform() {
	// Context
	const auth = useAuth()
	const { hasOneOfRoles } = useCurrentUserRoles()

	// Translations
	const t = useTrans(["dashboard", "investments"])

	// State for managing expanded charts
	const [selectedProjectType, setSelectedProjectType] =
		useState<ProjectTypeEnum | null>(null)

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("common:navigation.statistics.platform.link"),
				})}
			</title>

			<PageTemplate>
				{/** If logged in, show investment opportunities */}
				{auth.status === AuthStateStatusEnum.LOGGED_IN ? (
					<InvestmentOpportunityBanner className="mb-4" />
				) : null}

				{/* Funded Amount Pie Chart */}
				<FundedAmountPieChart
					setSelectedProjectType={setSelectedProjectType}
				/>

				{ProjectBondsTypes.includes(
					selectedProjectType as ProjectTypeEnum,
				) ? (
					<ProjectTypeBonds
						onClose={() => setSelectedProjectType(null)}
					/>
				) : null}

				{selectedProjectType === ProjectTypeEnum.SolarFunds ? (
					<ProjectTypeSolarFundsInfo
						onClose={() => setSelectedProjectType(null)}
					/>
				) : null}

				{selectedProjectType === ProjectTypeEnum.SolarLease ? (
					<ProjectTypeSolarLeaseInfo
						onClose={() => setSelectedProjectType(null)}
					/>
				) : null}

				{/** Bonds projects 'SOLAR_SHARES' */}
				<>
					<ProjectsOverviewTable />

					<FinancialPerformanceGraph />

					<ExpectedVsActualGraph />

					{hasOneOfRoles(UserRoles.admin) ? (
						<ProjectOwnersOverview />
					) : null}
				</>
			</PageTemplate>
		</>
	)
}
